import React, { memo } from "react";
import PropTypes from "prop-types";
import File from "./exportType";
import styles from "./Download.module.scss";

const ExportFiles = ({ children }) => {
  const files = [];
  React.Children.forEach(children, child => {
    if (child?.type === File) {
      files.push(child);
    }
  });
  return <div className={styles.content}>{files}</div>;
};

ExportFiles.propTypes = {
  children: PropTypes.node.isRequired
};

export default memo(ExportFiles);
